import { Vue, Component } from 'vue-property-decorator'
import { alert } from '@/util/modal'
import { camelCase } from 'lodash'

const ignoreCodes = { 401: 1, 403: 1 }

/**
 * 本系统所有页面、组件的基类
 */
@Component
export default class ViewBase extends Vue {
  /**
   * 显示错误信息
   * @param msg 错误信息
   */
  showError(msg: string) {
    alert(msg)
  }

  /**
   * 将错误格式化成字符串
   * @param ex 错误对象
   */
  formatError(ex: any = {}) {
    // const msg = ex.msg || ex.s ? `${ex.s} ${ex.msg}` : String(ex)
    const msg = ex.msg || ex
    return msg
  }

  /**
   * 统一处理 ajax catch 异常
   * @param ex 错误对象
   */
  handleError(ex: any = {}) {
    if (!(ex.s in ignoreCodes)) {
      const msg = this.formatError(ex)
      this.showError(msg)
      // tslint:disable-next-line
      console.error(msg)
    }
  }
}
